(function () {
  if (window.__mpMergeDuplicateCartLinesInit) return;
  window.__mpMergeDuplicateCartLinesInit = true;

  var nativeFetch = window.fetch.bind(window);

  // The Liquid template (snippets/cart-products.liquid) already renders the
  // MERGED total on the visible ("primary") row of a same-variant discount
  // split, and marks that row with data-merged-primary="true". This script's
  // only job is to reinterpret that row's quantity edits: the native
  // component-cart-items.js sends /cart/change.js with a positional `line`
  // and a target `quantity`, meaning "set this ONE real cart line's quantity
  // to X". For a merged row, X is the DESIRED TOTAL across all real lines
  // sharing that variant, not any single line's own quantity.
  //
  // IMPORTANT: Shopify recomputes the BXGY paid/free split (and assigns a
  // NEW line key to the result) after EVERY individual /cart/change.js or
  // /cart/add.js call that touches a variant's total quantity in the cart.
  // A plan computed once from a single stale snapshot (e.g. "reduce line A
  // by 2, then line B by 1") breaks the moment step 1 causes Shopify to
  // reshuffle line B's key out from under step 2 (confirmed empirically:
  // the second call silently no-ops against a line that no longer exists).
  // So decrements are done as a LOOP that re-fetches /cart.js before every
  // single-line change and always targets whichever line currently holds
  // the most quantity (minimizes steps, and is always safe since it can
  // never ask to remove more than that line currently has).

  function isCartChangeUrl(u) {
    var p = typeof u === 'string' ? u : (u && u.url) || '';
    return /\/cart\/change(\.js)?(\?|$)/.test(p);
  }

  function rowIsMergedPrimary(line) {
    var input = document.querySelector('input[data-cart-line="' + line + '"]');
    var row = input && input.closest('tr.cart-items__table-row');
    return !!row && row.getAttribute('data-merged-primary') === 'true';
  }

  function sameVariantGroup(cart, variantId) {
    return cart.items.filter(function (i) {
      return i.variant_id === variantId && Object.keys(i.properties || {}).length === 0;
    });
  }

  function fetchCart() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  // Reduce the total quantity held by a variant's group by `amount`,
  // one real line at a time, always re-reading fresh cart state first so
  // we never act on a line key Shopify has already superseded.
  function reduceGroupBy(variantId, amount) {
    if (amount <= 0) return Promise.resolve();
    return fetchCart().then(function (cart) {
      var lines = sameVariantGroup(cart, variantId);
      if (!lines.length) return; // nothing left to reduce
      lines.sort(function (a, b) { return b.quantity - a.quantity; });
      var target = lines[0];
      var take = Math.min(amount, target.quantity);
      return nativeFetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: target.key, quantity: target.quantity - take })
      }).then(function () {
        var remaining = amount - take;
        if (remaining > 0) return reduceGroupBy(variantId, remaining);
      });
    });
  }

  function handleMergedChange(bodyObj, originalInput, originalInit) {
    return fetchCart()
      .then(function (cart) {
        var targetLine = cart.items[bodyObj.line - 1];
        if (!targetLine) return nativeFetch(originalInput, originalInit);

        var groupLines = sameVariantGroup(cart, targetLine.variant_id);
        if (groupLines.length < 2) return nativeFetch(originalInput, originalInit);

        var currentTotal = groupLines.reduce(function (s, i) { return s + i.quantity; }, 0);
        var desiredTotal = Math.max(0, bodyObj.quantity);
        var delta = desiredTotal - currentTotal;
        if (delta === 0) return nativeFetch(originalInput, originalInit);

        var variantId = targetLine.variant_id;
        var opChain;
        if (delta > 0) {
          opChain = nativeFetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: delta }] })
          });
        } else {
          opChain = reduceGroupBy(variantId, -delta);
        }

        return opChain.then(function () {
          // Universal no-op call so the response carries the requested
          // section HTML in exactly the shape component-cart-items.js
          // expects, regardless of which branch above ran and regardless of
          // whether the cart ended up empty.
          return nativeFetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              updates: {},
              sections: bodyObj.sections,
              sections_url: bodyObj.sections_url
            })
          });
        });
      })
      .catch(function () {
        return nativeFetch(originalInput, originalInit);
      });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;

    if (isCartChangeUrl(url) && init && typeof init.body === 'string') {
      var bodyObj = null;
      try { bodyObj = JSON.parse(init.body); } catch (e) { bodyObj = null; }

      if (bodyObj && typeof bodyObj.line === 'number' && rowIsMergedPrimary(bodyObj.line)) {
        return handleMergedChange(bodyObj, input, init);
      }
    }

    return nativeFetch(input, init);
  };
})();
